import React from 'react';

import { LinkList } from '../../../../components';
import type { ViewNestedTaxonomiesProps } from '..';

const ViewNestedTaxonomiesSimple: React.FC<Pick<ViewNestedTaxonomiesProps, 'entities'>> = ({ entities }) => (
  <LinkList>
    {entities.map((entity) => {
      const taxonomyTerm = entity.toJS();
      const uuid = taxonomyTerm.uuid[0].value;
      const langcode = taxonomyTerm.langcode[0].value;
      const name = taxonomyTerm.name[0].value;
      const key = `${uuid}:${langcode}`;

      return (
        <LinkList.TertiaryItem
          key={key}
          title={name}
          link={taxonomyTerm.paths.nl}
        />
      );
    })}
  </LinkList>
);

export default ViewNestedTaxonomiesSimple;
